import { RemoveCache } from './usecases/remove-cache'

export class RemoveLocalStorage implements RemoveCache {
  remove(): void {
    window.localStorage.clear()
  }
}
